import { render } from "./CartItem.vue?vue&type=template&id=0632dc7a&scoped=true"
import script from "./CartItem.vue?vue&type=script&lang=js"
export * from "./CartItem.vue?vue&type=script&lang=js"

import "./CartItem.vue?vue&type=style&index=0&id=0632dc7a&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0632dc7a"]])

export default __exports__